// extracted by mini-css-extract-plugin
export default {"container":"Signup_container__l1Pyq","innerBox":"Signup_innerBox__X0Wqi","footer":"Signup_footer__sRAaU","error":"Signup_error__+UN1u"};